import React, { useState, useEffect } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const DualPriceSlider = ({ minPrice, maxPrice, onChange }) => {
  // fallback para quando vier null
  const safeMin = minPrice ?? 0;
  const safeMax = maxPrice ?? 5000;

  const [range, setRange] = useState([safeMin, safeMax]);

  // Se props mudarem, atualizar o state
  useEffect(() => {
    if (minPrice != null && maxPrice != null) {
      setRange([minPrice, maxPrice]);
    }
  }, [minPrice, maxPrice]);

  const handleSliderChange = (value) => {
    setRange(value);
    onChange?.(value);
  };

  const formatPrice = (value) =>
    value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 0,
    });

  if (minPrice == null || maxPrice == null) {
    return <div className="text-muted">Faixa de preço indisponível</div>;
  }

  return (
    <div className="dual-price-slider">
      <div className="d-flex justify-content-between fw-bold mb-2">
        <span>Min: {formatPrice(range[0])}</span>
        <span>Max: {formatPrice(range[1])}</span>
      </div>

      <Slider
        range
        min={safeMin}
        max={safeMax}
        step={500}
        value={range}
        onChange={handleSliderChange}
        allowCross={false}
        trackStyle={[{ backgroundColor: "#5C6BC0" }]}
        railStyle={{ backgroundColor: "#ddd" }}
        handleStyle={[
          { borderColor: "#5C6BC0", backgroundColor: "#5C6BC0" },
          { borderColor: "#5C6BC0", backgroundColor: "#5C6BC0" },
        ]}
      />
    </div>
  );
};

export default DualPriceSlider;
